import React from 'react';
import PropTypes from 'prop-types';
import { strings } from '../../../../localization';
import FleetioIntegration from './FleetioIntegration';
import WhiparoundIntegration from './WhiparoundIntegration';


export default class Integrations extends React.PureComponent {

    static propTypes = {

        expandOrCollapseStateForUIReferences: PropTypes.func.isRequired,
        integrationsExpandReference: PropTypes.string.isRequired,
        integrationsExpandReferenceIsExpanded: PropTypes.bool.isRequired,

        
        integrationsFleetioCredentialsExpandReference: PropTypes.string.isRequired,
        integrationsFleetioCredentialsExpandReferenceIsExpanded: PropTypes.bool.isRequired,

        integrationsWhiparoundCredentialsExpandReference: PropTypes.string.isRequired,
        integrationsWhiparoundCredentialsExpandReferenceIsExpanded: PropTypes.bool.isRequired,

        
        showConfirmationDialog: PropTypes.func.isRequired,
        dismissConfirmationDialog: PropTypes.func.isRequired,

        // fleetio
        integrationsFleetioCredentialsPending: PropTypes.bool.isRequired,
        timeoutIntegrationsFleetioCredentials: PropTypes.func.isRequired,
        integrationsFleetioCredentialsAccountToken: PropTypes.string,
        integrationsFleetioCredentialsApiKey: PropTypes.string,
        integrationsFleetioCredentialsIntegrationId: PropTypes.string,
        applyIntegrationsFleetioCredentials: PropTypes.func.isRequired,
        integrationsFleetioCredentialsStatus: PropTypes.string,
        integrationsFleetioCredentialsErrorMessage: PropTypes.string,
        integrationsFleetioCredentialsStatusMessage: PropTypes.string,
        integrationsFleetioCredentialsVerificationPending: PropTypes.bool.isRequired,
        integrationsFleetioCredentialsVerificationIsValid: PropTypes.bool.isRequired,
        integrationsFleetioCredentialsVerificationErrorMessage: PropTypes.string,

        //whiparound
        integrationsWhiparoundCredentialsPending: PropTypes.bool.isRequired,
        timeoutIntegrationsWhiparoundCredentials: PropTypes.func.isRequired,
        integrationsWhiparoundCredentialsApiKey: PropTypes.string,
        integrationsWhiparoundCredentialsIntegrationId: PropTypes.string,
        applyIntegrationsWhiparoundCredentials: PropTypes.func.isRequired,
        integrationsWhiparoundCredentialsStatus: PropTypes.string,
        integrationsWhiparoundCredentialsErrorMessage: PropTypes.string,
        integrationsWhiparoundCredentialsStatusMessage: PropTypes.string,
        integrationsWhiparoundCredentialsVerificationPending: PropTypes.bool.isRequired,
        integrationsWhiparoundCredentialsVerificationIsValid: PropTypes.bool.isRequired,
        integrationsWhiparoundCredentialsVerificationErrorMessage: PropTypes.string

        
    }

    expandOrCollapseSectionsAndSubsections = (isExpanded) => {
        this.props.expandOrCollapseStateForUIReferences(isExpanded,[
            this.props.integrationsExpandReference,
            this.props.integrationsWhiparoundCredentialsExpandReference,
            this.props.integrationsFleetioCredentialsExpandReference
        ]);
    }

    render() {
        
        return (
            <div id="component_document_id_integrations">
                <h3>
                    <button
                        className={this.props.integrationsExpandReferenceIsExpanded ? "settings-disclosure-wrapper" : "settings-disclosure-wrapper collapsed"}
                        onClick={() => {
                            this.expandOrCollapseSectionsAndSubsections(!this.props.integrationsExpandReferenceIsExpanded)}
                        }>
                        {strings.settings_global_integrations_header}
                        <i className="material-icons disclosure">keyboard_arrow_up</i>
                    </button>
                </h3>
                <div className='settings-section-description'>
                    <div>
                        {strings.settings_global_integrations_description}
                    </div>
                    <div>
                        <i>{strings.settings_global_integrations_sub_description}</i>
                    </div>
                </div>

                {/* fleetio integration */}
                <FleetioIntegration
                    expandOrCollapseStateForUIReferences = {this.props.expandOrCollapseStateForUIReferences}
                    integrationsExpandReference = {this.props.integrationsExpandReference}
                    integrationsExpandReferenceIsExpanded = {this.props.integrationsExpandReferenceIsExpanded}
                    integrationsFleetioCredentialsExpandReference = {this.props.integrationsFleetioCredentialsExpandReference}
                    integrationsFleetioCredentialsExpandReferenceIsExpanded = {this.props.integrationsFleetioCredentialsExpandReferenceIsExpanded}
                    integrationsFleetioCredentialsPending = {this.props.integrationsFleetioCredentialsPending || this.props.globalSettingsPending}
                    timeoutIntegrationsFleetioCredentials = {this.props.timeoutIntegrationsFleetioCredentials}
                    integrationsFleetioCredentialsAccountToken = {this.props.integrationsFleetioCredentialsAccountToken}
                    integrationsFleetioCredentialsApiKey = {this.props.integrationsFleetioCredentialsApiKey}
                    integrationsFleetioCredentialsIntegrationId = {this.props.integrationsFleetioCredentialsIntegrationId}
                    applyIntegrationsFleetioCredentials = {this.props.applyIntegrationsFleetioCredentials}
                    integrationsFleetioCredentialsErrorMessage = {this.props.integrationsFleetioCredentialsErrorMessage}
                    integrationsFleetioCredentialsStatus = {this.props.integrationsFleetioCredentialsStatus}
                    integrationsFleetioCredentialsStatusMessage = {this.props.integrationsFleetioCredentialsStatusMessage}
                    integrationsFleetioCredentialsVerificationPending = {this.props.integrationsFleetioCredentialsVerificationPending || this.props.globalSettingsPending}
                    integrationsFleetioCredentialsVerificationIsValid = {this.props.integrationsFleetioCredentialsVerificationIsValid}
                    integrationsFleetioCredentialsVerificationErrorMessage = {this.props.integrationsFleetioCredentialsVerificationErrorMessage}
                    showConfirmationDialog = {this.props.showConfirmationDialog}
                    dismissConfirmationDialog = {this.props.dismissConfirmationDialog}
                />


                { /* whiparound integration */ }
                <WhiparoundIntegration
                    expandOrCollapseStateForUIReferences = {this.props.expandOrCollapseStateForUIReferences}
                    integrationsExpandReference = {this.props.integrationsExpandReference}
                    integrationsExpandReferenceIsExpanded = {this.props.integrationsExpandReferenceIsExpanded}
                    integrationsWhiparoundCredentialsExpandReference = {this.props.integrationsWhiparoundCredentialsExpandReference}
                    integrationsWhiparoundCredentialsExpandReferenceIsExpanded = {this.props.integrationsWhiparoundCredentialsExpandReferenceIsExpanded}
                    integrationsWhiparoundCredentialsPending = {this.props.integrationsWhiparoundCredentialsPending || this.props.globalSettingsPending}
                    timeoutIntegrationsWhiparoundCredentials = {this.props.timeoutIntegrationsWhiparoundCredentials}
                    integrationsWhiparoundCredentialsApiKey = {this.props.integrationsWhiparoundCredentialsApiKey}
                    integrationsWhiparoundCredentialsIntegrationId = {this.props.integrationsWhiparoundCredentialsIntegrationId}
                    applyIntegrationsWhiparoundCredentials = {this.props.applyIntegrationsWhiparoundCredentials}
                    integrationsWhiparoundCredentialsErrorMessage = {this.props.integrationsWhiparoundCredentialsErrorMessage}
                    integrationsWhiparoundCredentialsStatus = {this.props.integrationsWhiparoundCredentialsStatus}
                    integrationsWhiparoundCredentialsStatusMessage = {this.props.integrationsWhiparoundCredentialsStatusMessage}
                    integrationsWhiparoundCredentialsVerificationPending = {this.props.integrationsWhiparoundCredentialsVerificationPending || this.props.globalSettingsPending}
                    integrationsWhiparoundCredentialsVerificationIsValid = {this.props.integrationsWhiparoundCredentialsVerificationIsValid}
                    integrationsWhiparoundCredentialsVerificationErrorMessage = {this.props.integrationsWhiparoundCredentialsVerificationErrorMessage}
                    showConfirmationDialog = {this.props.showConfirmationDialog}
                    dismissConfirmationDialog = {this.props.dismissConfirmationDialog}
                />
            </div>
        );
    }
}

